<div class="card mt-0 border-0">

  <div class="card-body pb-0">
    <h5 class="card-title">
      <app-lineicon [line]="line().getNumber()" [abbreviate]="false"></app-lineicon>
    </h5>
    <table class="table {{getLineClass('border')}}">
      <tbody>
        @for(place of line().getStartingPlaces(); track place.getId()){
          <ng-container *ngTemplateOutlet="placeRow; context: {place:place, s11Player: place.getPlayer(), currentTeam: getCurrentTeam(place.getPlayer())}">
          </ng-container>
        }
        <ng-container *ngTemplateOutlet="placeRow; context: {place:line().getSubstitute(), s11Player: line().getSubstitute().getPlayer(), currentTeam: getCurrentTeam(line().getSubstitute().getPlayer())}">
        </ng-container>
      </tbody>
    </table>
  </div>
</div>
<ng-template #placeRow let-place="place" let-s11Player="s11Player" let-currentTeam="currentTeam">
  @if(processing()) {
    <tr>
      <td colspan=3 class="text-center">
        <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
      </td>
    </tr>
  }
  @if(!processing()) {
    <tr (click)="substituteAction(place)" ngClass="{'pointer': s11Player}">
      <td class="{{getSubstituteClass(place.isSubstitute())}}">
        @if(s11Player) {
          <span>{{s11Player.getPerson().getName()}}</span>
        }
        @if(!s11Player) {
          <button type="button" class="btn btn-outline-danger btn-sm" (click)="substitute.emit(place)">
            kies een {{place.isSubstitute() ? 'wissel' : 'speler'}}
          </button>
        }
        @if(place.isSubstitute()) {
          <span class="badge badge-reserve ms-1">r</span>
        }
      </td>
      <td class="{{getSubstituteClass(place.isSubstitute())}}">
        @if(currentTeam) {
          <app-team-name [team]="currentTeam" [fullName]="false"></app-team-name>
        }
      </td>
      <td class="text-end" class="{{getSubstituteClass(place.isSubstitute())}}">
        @if(!hasLineSubstitution(place.getLine()) && !place.isSubstitute()) {
          <button type="button" class="btn btn-primary btn-sm">
            <fa-icon [icon]=faSignOutAlt></fa-icon>
          </button>
        }
        @if(hasLineSubstitution(place.getLine()) && place.isSubstitute()) {
          <button type="button" class="btn btn-primary btn-sm">
            <fa-icon [icon]=faTrashAlt></fa-icon>
          </button>
        }
      </td>
    </tr>
  }
</ng-template>